<pfx-form-wrapper
  [form]="notesForm"
  [(loading)]="loading"
  (canceledEdit)="handleEditCanceled()"
  (submittedForm)="handleSubmit()"
>
  <form [formGroup]="notesForm">
    <pfx-textarea-input
      class="w-full mb-4"
      formControlName="notes"
      label=""
    ></pfx-textarea-input>
  </form>
</pfx-form-wrapper>
